import {Component, OnInit} from '@angular/core';
import {CatchService} from '../../../services/catch.service';
import {Catch, CatchStatus} from '../../../models/catch';
import {RunnerService} from "../../../services/runner.service";
import {CatcherService} from "../../../services/catcher.service";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Component({
  selector: 'app-catches',
  templateUrl: './catches.component.html',
  styles: []
})
export class CatchesComponent implements OnInit {

  lat = 53.6464827;
  long = -2.724244;
  catchesWithLocation$: Observable<Catch[]>;

  constructor(public catchService: CatchService, public runnerService: RunnerService, public catcherService: CatcherService) {
  }

  ngOnInit(): void {
    this.catchesWithLocation$ = this.catchService.catches$.pipe(
      map(catches => (catches || []).filter(c => c && c.lat != null && c.long != null))
    );
  }

  protected readonly alert = alert;
  protected readonly CatchStatus = CatchStatus;
}
